module.exports = __webpack_public_path__ + "static/media/OPX.0a4dd254.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/currencies/OPX.svg
// module id = 2368
// module chunks = 7